/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PermissionResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PermissionResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PermissionResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.PermissionResponse);
  }
}(this, function(ApiClient, PermissionResponse) {
  'use strict';




  /**
   * The PermissionResponse model module.
   * @module model/PermissionResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PermissionResponse</code>.
   * The response object for permission.
   * @alias module:model/PermissionResponse
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>PermissionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PermissionResponse} obj Optional instance to populate.
   * @return {module:model/PermissionResponse} The populated <code>PermissionResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (data.hasOwnProperty('children')) {
        obj['children'] = ApiClient.convertToType(data['children'], [PermissionResponse]);
      }
    }
    return obj;
  }

  /**
   * The ID of the permission. The value is in the format: \"HttpMethod Path\", like \"GET api/v1/permission\".
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * The name of the permission. In GIS Server, this value used to store the name of the route, like \"[Route(Name = \"Get permission\")]\"
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * The text of the permission. The value is in the format: \"HttpMethod Path\", like \"GET api/v1/permission\".
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * The children nodes of the permission.
   * @member {Array.<module:model/PermissionResponse>} children
   */
  exports.prototype['children'] = undefined;



  return exports;
}));



